export const DisplayAmount = (amount: string | number | null) => {
    const value = Number(amount)
    if (amount && !isNaN(value)) {
        let nf = new Intl.NumberFormat();
        return `₹${nf.format(value)}`; // "1,234,567,890"
    }
    return "₹0";// can use &#8377; instade of ₹
}